// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__21FC3","box":"WorkspacesBox_box__1epFh","node":"WorkspacesBox_node__2Dips"};